import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PromoBanner from '../components/PromoBanner';
import { CheckCircle, Clock, Book, Award } from 'lucide-react';

const AllInOneBundlePage = () => {
  const bundle = {
    id: 2,
    title: "All-in-One Lifetime Access Bundle",
    description: "Complete cloud learning package with everything you need + FUTURE courses",
    originalPrice: 1729,
    discountedPrice: 499,
    savings: 1230,
    courses: [
      // Study Notes
      {
        title: "Study Notes: AWS Certified Cloud Practitioner",
        price: 29,
        instructor: "Lucy Wang",
        image: "/course-covers/4.png"
      },
      {
        title: "Study Notes: AWS Certified AI Practitioner",
        price: 39,
        instructor: "Lucy Wang",
        image: "/course-covers/study-notes-ai-practitioner.png"
      },
      {
        title: "Study Notes: AWS Certified Solutions Architect - Associate",
        price: 39,
        instructor: "Lucy Wang",
        image: "/course-covers/6.png"
      },
      {
        title: "Study Notes: AWS Certified Developer - Associate",
        price: 39,
        instructor: "Lucy Wang",
        image: "/course-covers/study-notes-developer-associate.jpg"
      },
      {
        title: "Study Notes: AWS Certified CloudOps Engineer - Associate",
        price: 39,
        instructor: "Lucy Wang",
        image: "/course-covers/study-notes-cloudops.png"
      },
      // Practice Exams
      {
        title: "AWS Certified Cloud Practitioner Practice Tests",
        price: 29,
        instructor: "Lucy Wang",
        image: "/course-covers/practice-exams-cloud-practitioner.png"
      },
      {
        title: "AWS Certified AI Practitioner Practice Tests",
        price: 29,
        instructor: "Lucy Wang",
        image: "/course-covers/ai-practice-tests.png"
      },
      {
        title: "AWS Certified Solutions Architect - Associate Practice Tests",
        price: 29,
        instructor: "Lucy Wang",
        image: "/course-covers/practice-exams-solutions-architect.png"
      },
      {
        title: "AWS Certified Developer - Associate Practice Tests",
        price: 29,
        instructor: "Lucy Wang",
        image: "/course-covers/practice-exams-developer-associate.jpg"
      },
      // Project Courses
      {
        title: "Build: 5 Beginner AWS Cloud Projects",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/2.png"
      },
      {
        title: "Build: 5 Intermediate AWS Cloud Projects",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/3.png"
      },
      {
        title: "Build: 5 Advanced AWS Cloud Projects",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/5.png"
      },
      // Role-Based Projects
      {
        title: "5 AWS Cloud Projects to Become a Cloud Support Engineer",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/cloud-support-engineer-projects.jpg"
      },
      {
        title: "5 AWS Cloud Projects to Become a Solutions Architect",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/solutions-architect.png"
      },
      {
        title: "5 AWS Projects to Become a Cloud Engineer",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/cloud-engineer-projects.png"
      },
      {
        title: "5 AWS Projects to Become a Cloud AI/ML Engineer",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/ai-ml-engineer-projects.png"
      },
      {
        title: "5 AWS Projects to Become a Cloud Security Engineer",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/cloud-security-engineer-projects.png"
      },
      {
        title: "5 AWS Cloud Projects to Become a DevOps Engineer",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/devops-engineer-projects.png"
      },
      {
        title: "5 Beginner Azure Cloud Projects",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/azure-beginner-projects.png"
      },
      {
        title: "5 Intermediate Azure Cloud Projects",
        price: 69,
        instructor: "Lucy Wang",
        image: "/course-covers/azure-intermediate-projects.png"
      },
      {
        title: "Study Notes: Azure Administrator Associate",
        price: 39,
        instructor: "Lucy Wang",
        image: "/course-covers/study-notes-azure-administrator.png"
      },
      // Career & Other
      {
        title: "AWS Interview Mastery: Get Hired in the Cloud",
        price: 129,
        instructor: "Lucy Wang",
        image: "/course-covers/1.png"
      },
      {
        title: "The Part-Time Tech Career YouTuber",
        price: 129,
        instructor: "Lucy Wang",
        image: "/course-covers/9.png"
      }
    ],
    image: "/bundle-covers/all-in-one.jpg",
    features: [
      "Complete cloud learning journey",
      "All current and FUTURE courses included",
      "Multiple AWS certifications covered",
      "Career development guidance",
      "25+ hands-on cloud projects",
      "Lifetime access with updates"
    ]
  };

  const percentageSaved = Math.round((bundle.savings / bundle.originalPrice) * 100);

  return (
    <div className="min-h-screen bg-gray-50">
      <PromoBanner />
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="container">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left Side - Bundle Info */}
              <div>
                <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
                  <Award size={16} />
                  Best Value - Limited Time
                </div>
                
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                  {bundle.title}
                </h1>
                
                <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                  {bundle.description}
                </p>
                
                {/* Pricing */}
                <div className="mb-8">
                  <div className="flex items-center gap-4 mb-2">
                    <span className="text-3xl font-bold text-gray-500 line-through">${bundle.originalPrice}</span>
                    <span className="text-4xl font-bold text-green-600">${bundle.discountedPrice}</span>
                    <span className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                      Save {percentageSaved}%
                    </span>
                  </div>
                  <p className="text-lg text-gray-600">You save ${bundle.savings}!</p>
                </div>
                
                {/* Features */}
                <div className="mb-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">What's included:</h3>
                  <ul className="space-y-3">
                    {bundle.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <CheckCircle className="text-green-500 mt-0.5 flex-shrink-0" size={20} />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                {/* CTA Button */}
                <a 
                  href="https://learn.zerotocloud.co/p/all-in-one-access-bundle"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-lg transition-all duration-200 mb-4 inline-block text-center"
                >
                  Get Complete Bundle - ${bundle.discountedPrice}
                </a>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                  <p className="text-sm text-yellow-800 text-center font-medium">
                    <strong>Note:</strong> The price will rise as new courses are added. Purchase early and get lifetime access.
                  </p>
                </div>
              </div>
              
              {/* Right Side - Bundle Image */}
              <div className="relative">
                <img 
                  src={bundle.image}
                  alt={bundle.title}
                  className="w-full rounded-xl shadow-2xl"
                />
                <div className="absolute top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                  Save ${bundle.savings}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Included Section */}
      <section className="py-16 bg-white">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              All Courses Included ({bundle.courses.length} Courses)
            </h2>
            
            <div className="space-y-6">
              {bundle.courses.map((course, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                  <div className="flex items-center gap-6">
                    <img 
                      src={course.image}
                      alt={course.title}
                      className="w-20 h-20 object-contain bg-white rounded-lg border border-gray-200"
                    />
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {course.title}
                      </h3>
                      <div className="flex items-center gap-4">
                        <span className="text-2xl font-bold text-gray-900">
                          ${course.price}
                        </span>
                        <span className="text-sm text-green-600 font-medium">
                          ✓ Included in bundle
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Bundle Summary */}
            <div className="mt-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 border border-blue-200">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Bundle Summary</h3>
                <div className="flex justify-center items-center gap-8 mb-6">
                  <div>
                    <div className="text-lg text-gray-600">Individual Price:</div>
                    <div className="text-2xl font-bold text-gray-500 line-through">${bundle.originalPrice}</div>
                  </div>
                  <div className="text-3xl text-gray-400">→</div>
                  <div>
                    <div className="text-lg text-gray-600">Bundle Price:</div>
                    <div className="text-3xl font-bold text-green-600">${bundle.discountedPrice}</div>
                  </div>
                </div>
                
                <a 
                  href="https://learn.zerotocloud.co/p/all-in-one-access-bundle"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-12 py-4 rounded-lg font-semibold text-xl hover:shadow-lg transition-all duration-200 inline-block text-center"
                >
                  Start Complete Journey - ${bundle.discountedPrice}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AllInOneBundlePage;